import './scss/style.scss';
import 'url-search-params-polyfill';
import 'bootstrap';
import 'jquery-validation';
import { tns } from '../node_modules/tiny-slider/src/tiny-slider';
import './contact-us';
import './contact';
import './membership';
import './work';
import './appointment';
import './test-covid';

$('header').load('header.html?v=20210701');
$('footer').load('footer.html?v=20210701');
$('#contact-us').load('block-contact-us.html?v=20210701');
$('#some-services').load('block-some-services.html?v=20210701');
$('#banner-member').load('block-banner-member.html?v=20210701');
$('#banner-internal-footer').load('block-banner-internal-footer.html?v=20210701');
$('#list-menu-additional-services').load('block-menu-additional-services.html?v=20210701');

if ($.contains(document.body, document.getElementById('slider-main'))) {

    var slider_main = tns({
        container: '#slider-main',
        items: 1,
        loop: true,
        slideBy: 'page',
        autoplay: true,
        speed: 1000,
        autoplayHoverPause: true,
        autoplayButtonOutput: false,
        controls: false,
        navPosition: 'bottom',
        lazyload: true,
    });

    $(window).on('load resize scroll', function(e) {
        $('.block-banner-main .slider-main .items').each(function(index, element) {
            if ($(window).width() > 900) {
                if ($(window).scrollTop() > 30) {
                    var ratio = Math.round((($(window).scrollTop() - $(this).offset().top) / $(this).height()) * 100);
                    $(this).css('background-position', 'center ' + parseInt(-(ratio * 1.5)) + 'px');
                }
            } else {
                $(this).css('background-position', 'center top');
            }
        });
    });
}

if ($.contains(document.body, document.getElementById('slider-carousel'))) {

    var slider_carousel = tns({
        container: '#slider-carousel',
        items: 1,
        slideBy: 'page',
        autoplay: true,
        autoplayHoverPause: true,
        autoplayButtonOutput: false,
        controls: false,
        nav: false,
        mouseDrag: true
    });

    document.querySelector('.btn-left').onclick = function() {
        slider_carousel.goTo('prev');
    };

    document.querySelector('.btn-right').onclick = function() {
        slider_carousel.goTo('next');
    };
}

$('.custom-file-input').on('change', function(event) {
    var inputFile = event.currentTarget;
    $(inputFile).parent().find('.custom-file-label').html(inputFile.files[0].name);
});
